export var Size;
(function (Size) {
    Size[Size["one"] = 1] = "one";
    Size[Size["two"] = 2] = "two";
    Size[Size["three"] = 3] = "three";
})(Size || (Size = {}));
export var Shape;
(function (Shape) {
    Shape["Square"] = "Square";
    Shape["RectangleA"] = "RectangleA";
    Shape["RectangleB"] = "RectangleB";
})(Shape || (Shape = {}));
export var VoucherState;
(function (VoucherState) {
    VoucherState[VoucherState["canReceive"] = 0] = "canReceive";
    VoucherState[VoucherState["Received"] = 1] = "Received";
    VoucherState[VoucherState["ComingSoon"] = 2] = "ComingSoon";
    VoucherState[VoucherState["RanOut"] = 3] = "RanOut";
    VoucherState[VoucherState["Expired"] = 4] = "Expired";
})(VoucherState || (VoucherState = {}));
